import React from 'react'
import { useTranslation } from 'react-i18next'
import iconWebPhone from '~/assets/svgs/icon-web-phone.svg?react'
import { useSettingsState } from '~/atoms/SettingsState'
import { SiteNavigationTab } from '~/pages/Home/SiteNavigation/shared/SiteNavigationTab'
import { TabImplementationProps } from '~/pages/Home/SiteNavigation/tabImplementations/TabImplementationTypes'
import { PhoneHub } from '~/pages/WebPhone/PhoneHub'
import { YealinkHeadset } from '~/pages/WebPhone/YealinkHeadset'

// #endregion

export const WebPhoneTab = ({
  id,
  isSelected,
  isCollapsed,
  onClick,
}: TabImplementationProps) => {
  const { canUseWebPhone } = useSettingsState()
  const { t } = useTranslation()

  return (
    <>
      {canUseWebPhone && <PhoneHub />}
      {window.electron && <YealinkHeadset electron={window.electron} />}
      <SiteNavigationTab
        id={id}
        title={t('nav.webPhone')}
        icon={iconWebPhone}
        isSelected={isSelected}
        isCollapsed={isCollapsed}
        onClick={onClick}
      />
    </>
  )
}
